import { lazyOnCompose } from 'owa-addins-core';
import { orchestrator } from 'satcheljs';
import { onComposeAddinsInitialized } from 'owa-mail-compose-actions';

orchestrator(onComposeAddinsInitialized, actionMessage => {
    lazyOnCompose.import().then(onCompose => {
        onCompose(actionMessage.hostItemIndex);
    });
});
